export enum Animations {
  Heartbeat,
  Wiggle,
}
